module.exports = __webpack_public_path__ + "img/icon_blacklist.5673b30a.svg";